import React from "react";
import { NavItem, NavLink } from "reactstrap";
import cx from "classnames";
import styles from "./TechnicalPropertiesTabs.module.scss";
import type { TechnicalDesignInputModes } from "stores/product";

interface TabItemProps {
  tabId: TechnicalDesignInputModes;
  label: string | React.ReactNode;
  isActive: boolean;
  onClick: (tabId: TechnicalDesignInputModes) => void;
}

export const TabItem: React.FC<TabItemProps> = ({
  tabId,
  label,
  isActive,
  onClick,
}) => (
  <NavItem className={cx("border-0", styles.tabLink)}>
    <NavLink
      className={cx("py-3 fw-bold fs-7 cursor-pointer text-center", {
        "bg-white text-info": isActive,
        "text-gray-700": !isActive,
        [styles.activeTab]: isActive,
      })}
      onClick={() => onClick(tabId)}
    >
      {label}
    </NavLink>
  </NavItem>
);
